module.exports = __webpack_public_path__ + "static/media/poster-thumbnail.6f7cda42.png";